module.exports = __webpack_public_path__ + "assets/91b38543699eea04adee6e4911bc830b.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/taylorice/Documents/Roc2/engine/public-src/spingames/panel/sounds/win/win_3.mp3
 ** module id = 59
 ** module chunks = 0
 **/